import { useRouterStore } from '@artup/client'

export default {
  /**
   * Initializes the applet
   */
  initialize () {
  },

  /**
   * Navigates to Error page
   */
  gotoError () {
    const { gotoRoute } = useRouterStore()
    gotoRoute({ name: 'error' })
  },

  /**
   * Navigates to Empty page
   */
  gotoEmpty () {
    const { gotoRoute } = useRouterStore()
    gotoRoute({ name: 'empty' })
  },
}
